var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Page",
    { staticStyle: { background: "white" }, attrs: { title: _vm.title } },
    [
      _c(
        "div",
        {
          ref: "CC",
          staticClass: "details_v",
          staticStyle: { "padding-bottom": "1rem" }
        },
        [
          _c(
            "div",
            { staticClass: "van-collapse-item__content " },
            [
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("课程名称：")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.pullList[0]["name"],
                      expression: "pullList[0]['name']"
                    }
                  ],
                  staticClass: "inputs",
                  attrs: {
                    type: "text",
                    placeholder: "请输入课程名称",
                    maxlength: "100",
                    disabled: "true"
                  },
                  domProps: { value: _vm.pullList[0]["name"] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.pullList[0], "name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("课程类型：")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pull-down-selects",
                    attrs: { "data-id": "10" },
                    on: {
                      click: function($event) {
                        return _vm.downSelections(1)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.pullList[1]["name"] || "全部") +
                        "\n                            "
                    ),
                    ""
                      ? _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("导师类型：")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pull-down-selects",
                    attrs: { "data-id": "10" },
                    on: {
                      click: function($event) {
                        return _vm.downSelections(2)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.pullList[2]["name"] || "全部") +
                        "\n                            "
                    ),
                    ""
                      ? _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("培训导师：")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pull-down-selects",
                    attrs: { "data-id": "10" },
                    on: {
                      click: function($event) {
                        return _vm.downSelections(3)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.pullList[3]["name"] || "全部") +
                        "\n                            "
                    ),
                    ""
                      ? _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex itemCenter cell-list-item cell-list-item-active"
                },
                [
                  _c("div", { staticClass: "birthday-flex-style-one titles" }, [
                    _vm._v("课程日期:")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "birthday-flex-style-one ",
                      on: {
                        click: function($event) {
                          return _vm.downSelections(4)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.pullList[4]["val"] || "请选择") +
                          "\n                            "
                      ),
                      ""
                        ? _c("img", {
                            staticClass: "uparrow",
                            attrs: {
                              src: require("@/assets/img/uparrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [_vm._v("-")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "birthday-flex-style-one",
                      on: {
                        click: function($event) {
                          return _vm.downSelections(5)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.pullList[5]["val"] || "请选择") +
                          "\n                            "
                      ),
                      ""
                        ? _c("img", {
                            staticClass: "uparrow",
                            attrs: {
                              src: require("@/assets/img/uparrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.U_RangeTimeList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass:
                      "flex itemCenter cell-list-item cell-list-item-active"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "birthday-flex-style-one  birthday-flex-style-one-ative",
                        on: {
                          click: function($event) {
                            return _vm.downTimetions(index, 1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(item.date || "请选择") +
                            "\n                            "
                        ),
                        ""
                          ? _c("img", {
                              staticClass: "uparrow",
                              attrs: {
                                src: require("@/assets/img/uparrow.png"),
                                alt: "",
                                srcset: ""
                              }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "birthday-flex-style-one birthday-flex-style-one-ative",
                        on: {
                          click: function($event) {
                            return _vm.downTimetions(index, 2)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              item.timeFrame == 1
                                ? "上午"
                                : item.timeFrame == 2
                                ? "下午"
                                : item.timeFrame == 3
                                ? "全天"
                                : "上午" || "上午"
                            ) +
                            "\n                            "
                        ),
                        ""
                          ? _c("img", {
                              staticClass: "uparrow",
                              attrs: {
                                src: require("@/assets/img/uparrow.png"),
                                alt: "",
                                srcset: ""
                              }
                            })
                          : _vm._e()
                      ]
                    )
                  ]
                )
              }),
              _vm._v(" "),
              ""
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex itemCenter cell-list-item  center-flex",
                      on: { click: _vm.addDate }
                    },
                    [
                      _vm._v(
                        "\n                               +\n                    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [_vm._v("国家：")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pull-down-selects",
                    attrs: { "data-id": "10" },
                    on: {
                      click: function($event) {
                        return _vm.downSelections(6)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.pullList[6]["name"] || "全部") +
                        "\n                            "
                    ),
                    ""
                      ? _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [_vm._v("城市：")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pull-down-selects",
                    attrs: { "data-id": "10" },
                    on: {
                      click: function($event) {
                        return _vm.downSelections(7)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.pullList[7]["name"] || "全部") +
                        "\n                            "
                    ),
                    ""
                      ? _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex itemCenter cell-list-item-feed addres-flex-cell"
                },
                [
                  _c("div", { staticClass: "input-title" }, [_vm._v("地点：")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "addres-flex feed",
                      staticStyle: { height: "auto", "min-height": "0.6rem" }
                    },
                    [
                      _vm._v(
                        "\n                          " +
                          _vm._s(_vm.pullList[8]["name"]) +
                          "\n                        "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("学员类型：")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pull-down-selects",
                    attrs: { "data-id": "10" },
                    on: {
                      click: function($event) {
                        return _vm.downSelections(9)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.pullList[9]["name"] || "全部") +
                        "\n                            "
                    ),
                    ""
                      ? _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("学员人数：")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.pullList[10]["name"],
                      expression: "pullList[10]['name']"
                    }
                  ],
                  staticClass: "inputs",
                  attrs: {
                    type: "text",
                    placeholder: "请输入学员人数",
                    maxlength: "50"
                  },
                  domProps: { value: _vm.pullList[10]["name"] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.pullList[10], "name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("课程费用币种：")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pull-down-selects",
                    attrs: { "data-id": "10" },
                    on: {
                      click: function($event) {
                        return _vm.downSelections(11)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.pullList[11]["name"] || "全部") +
                        "\n                            "
                    ),
                    _c("img", {
                      staticClass: "uparrow",
                      attrs: {
                        src: require("@/assets/img/uparrow.png"),
                        alt: "",
                        srcset: ""
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("单人费用：")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.pullList[12]["name"],
                      expression: "pullList[12]['name']"
                    }
                  ],
                  staticClass: "inputs",
                  attrs: {
                    type: "text",
                    placeholder: "请输入单人费用",
                    maxlength: "50",
                    disabled: "true"
                  },
                  domProps: { value: _vm.pullList[12]["name"] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.pullList[12], "name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("费用合计：")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.pullList[13]["name"],
                      expression: "pullList[13]['name']"
                    }
                  ],
                  staticClass: "inputs",
                  attrs: {
                    type: "text",
                    placeholder: "请输入费用合计",
                    maxlength: "50",
                    disabled: "true"
                  },
                  domProps: { value: _vm.pullList[13]["name"] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.pullList[13], "name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex itemCenter cell-list-item" }, [
                _c("div", { staticClass: "input-title" }, [
                  _vm._v("提交作品：")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "radio-flex" },
                  [
                    _c(
                      "van-radio-group",
                      {
                        staticClass: "neededShow-flex",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.pullList[14]["value"],
                          callback: function($$v) {
                            _vm.$set(_vm.pullList[14], "value", $$v)
                          },
                          expression: "pullList[14]['value']"
                        }
                      },
                      [
                        _c(
                          "van-radio",
                          {
                            attrs: { name: "1" },
                            scopedSlots: _vm._u([
                              {
                                key: "icon",
                                fn: function(props) {
                                  return _c("img", {
                                    staticClass: "radioImg",
                                    attrs: {
                                      src: props.checked
                                        ? _vm.Icon[0]
                                        : _vm.Icon[1]
                                    }
                                  })
                                }
                              }
                            ])
                          },
                          [
                            _vm._v(
                              "需要\n                                          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "van-radio",
                          {
                            attrs: { name: "0" },
                            scopedSlots: _vm._u([
                              {
                                key: "icon",
                                fn: function(props) {
                                  return _c("img", {
                                    staticClass: "radioImg",
                                    attrs: {
                                      src: props.checked
                                        ? _vm.Icon[0]
                                        : _vm.Icon[1]
                                    }
                                  })
                                }
                              }
                            ])
                          },
                          [
                            _vm._v(
                              "不需要\n                                          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "quillcontent" },
                [
                  _c("div", { staticClass: "show-title" }, [
                    _vm._v("课程介绍")
                  ]),
                  _vm._v(" "),
                  _c("quill-editor", {
                    staticClass: "ql_editor",
                    attrs: { content: _vm.content, options: _vm.editorOption }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "show-title" }, [
                _vm._v("课程时间范围")
              ]),
              _vm._v(" "),
              _vm._l(_vm.calendarLists, function(items, index) {
                return _c("div", { staticClass: "curriculum_time" }, [
                  _vm._v(
                    _vm._s(items.timeFrame) +
                      ":" +
                      _vm._s(items.date) +
                      "\n      "
                  )
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vant-collapse-flex" },
                [
                  _c(
                    "van-collapse",
                    {
                      model: {
                        value: _vm.activeNames_one,
                        callback: function($$v) {
                          _vm.activeNames_one = $$v
                        },
                        expression: "activeNames_one"
                      }
                    },
                    [
                      _c(
                        "van-collapse-item",
                        {
                          staticStyle: { padding: "0" },
                          attrs: {
                            title: "课程成员" + "(" + _vm.totalRow + ")",
                            name: "1"
                          }
                        },
                        [
                          _c(
                            "van-list",
                            {
                              ref: "adQ",
                              attrs: {
                                finished: _vm.finished,
                                "finished-text": "没有更多的数据了",
                                "loading-text": "正在加载数据",
                                "error-text": "加载失败请重试",
                                "immediate-check": false
                              },
                              on: { load: _vm.onLoad },
                              model: {
                                value: _vm.loading,
                                callback: function($$v) {
                                  _vm.loading = $$v
                                },
                                expression: "loading"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "member-list" },
                                _vm._l(_vm.memberList, function(item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "memberList-item"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex flexR",
                                          on: {
                                            click: function($event) {
                                              return _vm.toClientDetail(
                                                item.accountId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "first-items" },
                                            [
                                              _vm._v(
                                                "姓名：" + _vm._s(item.name)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "last-items" },
                                            [
                                              _vm._v(
                                                "性别：" +
                                                  _vm._s(item.genderName || "")
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "flex flexR" }, [
                                        _c("div", {
                                          staticClass: "first-items",
                                          on: {
                                            click: function($event) {
                                              return _vm.toClientDetail(
                                                item.accountId
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "last-items active",
                                            on: {
                                              click: function($event) {
                                                return _vm.lookProduction(
                                                  item.courseMemberId,
                                                  item.reviewUserId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.uploadedShow == 1
                                                  ? "查看作品"
                                                  : ""
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom", overlay: true },
                  model: {
                    value: _vm.showDownSelection,
                    callback: function($$v) {
                      _vm.showDownSelection = $$v
                    },
                    expression: "showDownSelection"
                  }
                },
                [
                  _c("van-picker", {
                    staticClass: "van-picker-li",
                    attrs: {
                      "show-toolbar": "",
                      title: "",
                      columns: _vm.downSelection,
                      "value-key": "name"
                    },
                    on: { cancel: _vm.onCancelCode, confirm: _vm.onConfirmCode }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom", overlay: true },
                  model: {
                    value: _vm.showTimeSelection,
                    callback: function($$v) {
                      _vm.showTimeSelection = $$v
                    },
                    expression: "showTimeSelection"
                  }
                },
                [
                  _c("van-datetime-picker", {
                    attrs: { type: "date", "min-date": _vm.minDate },
                    on: {
                      cancel: _vm.onCancelTime,
                      confirm: _vm.onConfirmTime
                    },
                    model: {
                      value: _vm.currentDate,
                      callback: function($$v) {
                        _vm.currentDate = $$v
                      },
                      expression: "currentDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom", overlay: true },
                  model: {
                    value: _vm.showDateSelection,
                    callback: function($$v) {
                      _vm.showDateSelection = $$v
                    },
                    expression: "showDateSelection"
                  }
                },
                [
                  _c("van-picker", {
                    staticClass: "van-picker-li",
                    attrs: {
                      "show-toolbar": "",
                      title: "",
                      columns: _vm.downSelection1,
                      "value-key": "name"
                    },
                    on: {
                      cancel: _vm.onCancelCode1,
                      confirm: _vm.onConfirmCode1
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom", overlay: true },
                  model: {
                    value: _vm.showDateTime,
                    callback: function($$v) {
                      _vm.showDateTime = $$v
                    },
                    expression: "showDateTime"
                  }
                },
                [
                  _c("van-datetime-picker", {
                    attrs: { type: "date", "min-date": _vm.minDate },
                    on: {
                      cancel: _vm.onCancelTime1,
                      confirm: _vm.onConfirmTime1
                    },
                    model: {
                      value: _vm.currentDate,
                      callback: function($$v) {
                        _vm.currentDate = $$v
                      },
                      expression: "currentDate"
                    }
                  })
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _vm.statusButton == 1 && _vm.hasModifyAuth
            ? _c("div", { staticClass: "bottom-button" }, [
                _c(
                  "div",
                  { staticClass: "div1", on: { click: _vm.cancelClass } },
                  [_vm._v("取消课程")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "div2", on: { click: _vm.changeTo } },
                  [_vm._v("修改课程")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "van-dialog",
            {
              attrs: {
                "show-cancel-button": "",
                "before-close": _vm.beforeClose
              },
              model: {
                value: _vm.showcancel,
                callback: function($$v) {
                  _vm.showcancel = $$v
                },
                expression: "showcancel"
              }
            },
            [
              _c("van-field", {
                attrs: { type: "textarea", placeholder: "请输入取消原因" },
                model: {
                  value: _vm.cancelCause,
                  callback: function($$v) {
                    _vm.cancelCause = $$v
                  },
                  expression: "cancelCause"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "returnTo" }, [
            _c("img", {
              staticClass: "back",
              attrs: { src: require("@/assets/return.png"), alt: "" },
              on: { click: _vm.returnTo }
            })
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d8c010b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d8c010b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lkcollege/details.vue
// module id = null
// module chunks = 